import { render, staticRenderFns } from "./CompensatedData.vue?vue&type=template&id=36f61905&"
import script from "./CompensatedData.vue?vue&type=script&lang=js&"
export * from "./CompensatedData.vue?vue&type=script&lang=js&"
import style0 from "./CompensatedData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports